import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavsComponent } from './navs/navs.component';
import { NavItemDirective } from './nav-item/nav-item.directive';
import { NavItemComponent } from './nav-item/nav-item.component';
import { NavPanelDirective } from './nav-panel/nav-panel.directive';
import { BadgeModule } from 'shared/badge/badge.module';

import { NavContentDirective } from './nav-content/nav-content.directive';
import { DynamicNavsComponent } from './dynamic-navs/dynamic-navs.component';


@NgModule({
  imports: [CommonModule, BadgeModule],
  declarations: [
    NavsComponent,
    NavItemDirective,
    NavPanelDirective,
    NavItemComponent,
    NavContentDirective,
    DynamicNavsComponent,
  ],
  exports: [
    NavsComponent,
    NavItemDirective,
    NavPanelDirective,
    NavItemComponent,
    NavContentDirective,
    DynamicNavsComponent,
   ],
  providers: []
})
export class NavModule { }
